// Video card on /workspace/:id: the YouTube or local video, or (for an empty draft) ways to add one.

import React, { useState, useCallback } from 'react';
import './uploadWorkspace.css';

import LinkWorkspace from './YTworkspaceupload/linkWorkspace';
import LocalWorkspace from './Localworkspaceupload/localWorkspace';
import LocalVideoDisplay from './Localworkspaceupload/LocalVideoDisplay';

const UploadWorkspace = ({
  isTranscriptAvailable,
  isLocalTranscriptAvailable,
  content_id,
  isYTProcessing,
  isLOCALProcessing,
  isTranscriptEmpty,
  isTranscriptError,
  onBeforeUpload,
  onAfterUpload,
}) => {
  // State to track if there's input in LinkWorkspace
  const [hasInput, setHasInput] = useState(false);

  // Stable so the children's Firestore listeners aren't re-created on every render
  const handleInputChange = useCallback(inputPresent => setHasInput(inputPresent), []);

  return (
    <div className="worklink-uploaddashboard">
      <div className="upload-workspace-container">
        {/* Render LinkWorkspace only if isLocalTranscriptAvailable and isLOCALProcessing are false */}
        {!isLocalTranscriptAvailable && !isLOCALProcessing && (
          <LinkWorkspace
            onInputChange={handleInputChange}
            content_id={content_id}
            isTranscriptAvailable={isTranscriptAvailable}
            isYTProcessing={isYTProcessing}
            isTranscriptError={isTranscriptError}
            onBeforeUpload={onBeforeUpload}
            onAfterUpload={onAfterUpload}
          />
        )}

        {/* Render LocalWorkspace only if hasInput, isLocalTranscriptAvailable, isYTProcessing, and isLOCALProcessing are false */}
        {!hasInput && !isLocalTranscriptAvailable && !isYTProcessing && !isLOCALProcessing && (
          <LocalWorkspace
            content_id={content_id}
            isLOCALProcessing={isLOCALProcessing}
            onBeforeUpload={onBeforeUpload}
            onAfterUpload={onAfterUpload}
          />
        )}

        {/* Conditionally render LocalVideoDisplay if isLocalTranscriptAvailable or isLOCALProcessing is true */}
        {(isLocalTranscriptAvailable || isLOCALProcessing) && (
          <LocalVideoDisplay
            content_id={content_id}
            isLocalTranscriptAvailable={isLocalTranscriptAvailable}
            isLOCALProcessing={isLOCALProcessing}
            isTranscriptEmpty={isTranscriptEmpty}
          />
        )}
      </div>
    </div>
  );
};

export default UploadWorkspace;
